module.exports = __webpack_public_path__ + "static/media/link.34c8bf2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transplant/icons/link.svg
// module id = 325
// module chunks = 1